export default "__VITE_ASSET__CpaGB6AY__"